/**
 * Set by `AuthContext.logout`/`logoutAll` the instant a sign-out starts, BEFORE the request and
 * before React commits anything: the redirect that follows (`navigate('/')`, `<Navigate
 * to="/login">`) must never meet the unsaved-changes dialog, not even for a frame. Cleared by
 * `UnsavedChangesProvider` when a session is active again.
 */
let sessionEnding = false

export const markSessionEnding = (): void => {
  sessionEnding = true
}

export const clearSessionEnding = (): void => {
  sessionEnding = false
}

export const isSessionEnding = (): boolean => sessionEnding
